import { render } from "./TaskBatchesView.vue?vue&type=template&id=888e0574"
import script from "./TaskBatchesView.vue?vue&type=script&lang=js"
export * from "./TaskBatchesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__